import {NoticeMessage} from '#/atoms/notice-message';
import {UIStatusContext} from '#/contexts/ui-status-provider';
import {useAnnouncements} from '#/hooks/query/use-announcements';
import {XMarkIcon} from '@heroicons/react/24/solid';
import {AnimatePresence} from 'framer-motion';
import {FunctionComponent, useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';

export const Announcements: FunctionComponent = () => {
  const {isMenuOpen, isActionMenuOpen} = useContext(UIStatusContext);

  const {t} = useTranslation('translation');

  const {data: messages = []} = useAnnouncements();
  const [dismissedMessagesIds, setDismissedMessagesIds] = useState<number[]>([]);
  const filteredMessages = messages.filter(message => !dismissedMessagesIds.includes(message.id));

  const dismissMessage = (id: number) => {
    setDismissedMessagesIds([...dismissedMessagesIds, id]);
  };
  const dismissAllMessages = () => {
    setDismissedMessagesIds(messages.map(message => message.id));
  };

  return (
    <AnimatePresence>
      {filteredMessages && filteredMessages.length > 0 && (
        <div
          className='fixed top-0 right-0 p-6 z-30 flex flex-col gap-3 w-full sm:max-w-notification data-[actionmenuopen=true]:hidden  lg:data-[actionmenuopen=true]:flex data-[menuopen=true]:hidden lg:data-[menuopen=true]:hidden  transition-opacity duration-200'
          data-menuopen={isMenuOpen}
          data-actionmenuopen={isActionMenuOpen}
        >
          <div className='relative flex flex-col gap-3'>
            <div className='absolute -inset-1 rounded-md blur-md bg-gradient-to-br to-white z-10 pointer-events-none' />
            {filteredMessages.map(message => (
              <NoticeMessage
                key={message.id}
                className='w-full shadow-lg shadow-black/25 z-50'
                theme={'notification'}
                action={() => dismissMessage(message.id)}
                actionButtonTitle=''
              >
                {message.message}
              </NoticeMessage>
            ))}
          </div>

          {filteredMessages.length > 1 && (
            <button
              className={
                'relative z-50 h-7 text-xs font-bold shadow-lg shadow-black/25 px-2 py-1 font-bold bg-deepblue text-white rounded-lg self-start flex justify-end items-center gap-1 whitespace-nowrap hover:opacity-70'
              }
              onClick={dismissAllMessages}
            >
              <XMarkIcon className={'z-50 w-3 h-3 fill-white stroke-white'} />
              <div className='z-50'>{t('actions.clear')}</div>
            </button>
          )}
        </div>
      )}
    </AnimatePresence>
  );
};
